module.exports = __webpack_public_path__ + "img/2-quad.123352f0.png";